
import React from 'react';
import useDarkOverlay from '@/hooks/header_menu/useDarkOverlay';
import { scrollToValuation } from '@/utils/header_menu/scrollUtils';
import DarkOverlay from './contact/DarkOverlay';
import ContactHeader from './contact/ContactHeader';
import ValuationBox from './contact/ValuationBox';
import ContactInfo from './contact/ContactInfo';
import FinalCTA from './contact/FinalCTA';

interface ContactSectionProps {
  onValuationClick: () => void;
}

const ContactSection = ({ onValuationClick }: ContactSectionProps) => {
  const { darkOverlayOpacity } = useDarkOverlay('contact-section');

  return (
    <section 
      id="contact-section"
      className="relative py-20 bg-gradient-to-b from-white to-gray-100 overflow-hidden"
    >
      <DarkOverlay darkOverlayOpacity={darkOverlayOpacity} />

      <div className="container mx-auto px-4 relative z-10">
        <ContactHeader darkOverlayOpacity={darkOverlayOpacity}/>
        <ValuationBox darkOverlayOpacity={darkOverlayOpacity} onValuationClick={onValuationClick}/>
        <ContactInfo darkOverlayOpacity={darkOverlayOpacity} />
        <FinalCTA darkOverlayOpacity={darkOverlayOpacity} onScrollToValuation={scrollToValuation} />
      </div>
    </section>
  );
};

export default ContactSection;
